import Skeleton from './Skeleton';

export default Skeleton;



// WEBPACK FOOTER //
// ./src/skeleton/index.js